import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import RightCTA from "@components/V2/Banners/RightCTABanner"
import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokRightCTABanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.RightCTABanner>) => {
  return (
    <RightCTA
      title={blok.title}
      description={blok.description}
      backgroundColor={blok.backgroundColor}
      bannerBackgroundColor={blok.bannerBackgroundColor}
      bannerSecondaryBackgroundColor={blok.bannerSecondaryBackgroundColor}
      CTATitle={blok.CTATitle}
      CTAText={blok.CTAText}
      CTALink={storyblokLinkToYocoLink(blok.CTALink) ?? ""}
      CTAColor={blok.CTAColor}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokRightCTABanner
